<template>
  <b-modal
    title="ویرایش دسته بندی جدید سوالات متداول"
    id="modal-faq-category-edit"
    centered
    ok-title="ویرایش"
    cancel-title="بستن"
    @ok="sendUpdateFaqCategoryRequest"
    @cancel="clearFaqCreateData"
    :okDisabled="!clonedCategoryDetails.title || !clonedCategoryDetails.slug"
  >
    <b-overlay :show="isLoading">
      <b-container fluid>
        <b-form-row>
          <b-col cols="12">
            <b-form-group label="عنوان دسته بندی" label-for="title">
              <b-form-input
                id="title"
                placeholder="ثبت و مدیریت آگهی"
                v-model="clonedCategoryDetails.title"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="نامک (URL)" label-for="slug">
              <b-form-input
                id="slug"
                placeholder="submit-manage-post"
                v-model="clonedCategoryDetails.slug"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="عکس دسته بندی" label-for="image">
              <b-form-file
                id="image"
                v-model="tempImageFileData"
                :state="Boolean(clonedImage)"
                placeholder="فایل خود را انتخاب کنید"
                @input="setBase64Image"
                drop-placeholder="فایل را اینجا رها کنید"
              ></b-form-file>
            </b-form-group>
            <img
              v-if="clonedCategoryDetails.fileData || clonedImage"
              :src="clonedImageSource"
              style="width: 6rem; height: 6rem; object-fit: contain"
            />
          </b-col>
        </b-form-row>
      </b-container>
    </b-overlay>
  </b-modal>
</template>

<script>
export default {
  emits: ["reFetch"],
  props: {
    categoryDetails: {
      type: Object,
      required: true,
    },
  },
  watch: {
    categoryDetails: {
      immediate: true,
      handler(val) {
        if (val) {
          this.clonedCategoryDetails = JSON.parse(JSON.stringify(val));
          this.clonedImage = this.clonedCategoryDetails.fileData;
        }
      },
    },
  },
  data() {
    return {
      isLoading: false,
      clonedCategoryDetails: null,
      tempImageFileData: null,
      clonedImage: null,
    };
  },
  methods: {
    clearFaqCreateData() {
      this.tempImageFileData = null;
    },
    closeFaqCreateModal() {
      this.$bvModal.hide("modal-faq-category-edit");
      this.clearFaqCreateData();
    },
    async sendUpdateFaqCategoryRequest(bvModalEvent) {
      bvModalEvent.preventDefault();
      try {
        if (!this.tempImageFileData) {
          delete this.clonedCategoryDetails.fileData;
        }
        this.isLoading = true;
        const _this = this;
        const faqUpdateSingleRequest = new FaqUpdateSingleRequest(_this);
        faqUpdateSingleRequest.setParams(_this.clonedCategoryDetails);
        await faqUpdateSingleRequest.fetch((res) => {
          if (res.isSuccess) {
            this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "دسته بندی با موفقیت ویرایش شد",
              },
            });
            _this.closeFaqCreateModal();
            _this.$emit("reFetch");
          } else {
            if (!res.isSuccess && res.errorMessage) {
              this.$toast({
                component: ToastificationContent,
                position: "bottom-center",
                props: {
                  title: "خطا در ویرایش دسته بندی",
                  icon: "XIcon",
                  variant: "danger",
                  text: res.errorMessage,
                },
              });
            }
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setBase64Image() {
      Helper.createFileAsBase64Image(this.tempImageFileData, (base64) => {
        this.clonedCategoryDetails.fileData = base64;
      });
      console.log(this.tempImageFileData);
      console.log(this.clonedCategoryDetails.fileData);
    },
  },
  computed: {
    clonedImageSource() {
      if (this.tempImageFileData) {
        return this.clonedCategoryDetails.fileData;
      } else if (!this.tempImageFileData) {
        return `https://api.faradidar.com/${this.clonedImage}`;
      }
    },
  },
  components: {
    BCol,
    BOverlay,
    BFormInput,
    BFormRow,
    BContainer,
    BFormGroup,
    BFormFile,
    BModal,
  },
};
import Helper from "@/libs/Helper";
import { FaqUpdateSingleRequest } from "@/libs/Api/FaqCategory/FaqCategoryRequests";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  BCol,
  BOverlay,
  BFormInput,
  BFormRow,
  BContainer,
  BFormGroup,
  BFormFile,
  BModal,
} from "bootstrap-vue";
</script>
